import {eachMonthOfInterval, endOfMonth, isValid, startOfMonth} from 'date-fns'
import {Provider} from '../../hooks/useProvider'

type Period = {
  startsAt: string,
  endsAt: string
}

export function getStartAndEndOfMonth(isoDate: string): Period {
  const date = new Date(isoDate)

  return {
    startsAt: startOfMonth(date).toISOString(),
    endsAt: endOfMonth(date).toISOString()
  }
}

type StatisticsStart = Pick<Provider, 'startedAt' | 'statisticsStartedAt'>

/**
 * PT-8066: the months of the date select, from the start of the statistics until now.
 * The statistics of a Ratings account can start before the copy trading, so those months show too.
 */
export function getAvailableMonths(provider: StatisticsStart, now: Date = new Date()): Date[] {
  const start = provider.statisticsStartedAt ?? provider.startedAt
  const first = start != null ? startOfMonth(new Date(start)) : null
  // A start in the future or an unreadable date would break the interval: only the current month shows.
  const from = first != null && isValid(first) && first <= now ? first : startOfMonth(now)

  return eachMonthOfInterval({start: from, end: now})
}
